import Controller from '@ember/controller';
import { inject as service } from '@ember/service';

class BrandSignupStepController extends Controller {
  @service router;

  get currentStep() {
    const { currentRouteName } = this.router;

    const signupStep = currentRouteName.endsWith('_loading')
      ? currentRouteName.slice(0, -8)
      : currentRouteName;

    return signupStep;
  }
}

export default BrandSignupStepController;
